import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - ${movie.categoryName}`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            热门
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          {size === 'large' && (
            <span className="text-xs text-accent-400 font-medium mb-1 block">{movie.categoryName}</span>
          )}
          <h3 className="text-sm md:text-base font-bold text-white truncate">{movie.title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <div className="flex items-center gap-0.5">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-xs text-accent-500"></i>
              </div>
              <span className="text-xs text-accent-400 font-semibold">{movie.rating}</span>
            </div>
            {size === 'large' && (
              <span className="text-xs text-foreground-400">{movie.year}</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}